import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes, ReactNode } from "react";
import { useId } from "react";

export function Field({
  label,
  help,
  error,
  children,
}: {
  label: string;
  help?: string;
  error?: string;
  children: (id: string) => ReactNode;
}) {
  const id = useId();
  return (
    <div className="ods-field">
      <label className="ods-label" htmlFor={id}>
        {label}
      </label>
      {children(id)}
      {help && !error ? <span className="ods-help">{help}</span> : null}
      {error ? (
        <span className="ods-error-text" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}

export function TextInput({ id, ...rest }: InputHTMLAttributes<HTMLInputElement> & { id?: string }) {
  return <input id={id} className="ods-input" {...rest} />;
}

export function Select({ id, children, ...rest }: SelectHTMLAttributes<HTMLSelectElement> & { id?: string }) {
  return (
    <select id={id} className="ods-select" {...rest}>
      {children}
    </select>
  );
}

export function TextArea({ id, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement> & { id?: string }) {
  return <textarea id={id} className="ods-textarea" {...rest} />;
}
